define('controllers/servicecards/servicecards.ctrl',['app'], function (app) {
    app.controller('ServiceCardsController', ['$state', '$scope', '$rootScope', 'ngDialog', 'auiDialog', 'serviceresource', '$sce', '$timeout',
        '$compile', 'auiAgreementHelper', 'biAnalyticService', 'UserInfoPreload',
        function ($state, $scope, $rootScope, ngDialog, auiDialog, servicecard, $sce, $timeout,
                  $compile, auiAgreementHelper, biAnalyticService, UserInfoPreload) {
            if (sessionStorage.getItem('emptyCard')) {
                sessionStorage.removeItem('emptyCard')
                auiDialog.warn("温馨提醒", "您访问的服务暂未开放或您无该服务访问权限，请尝试使用其他服务。");
            }

            $scope.clickCard = function (card, event, cate) {
                var menuName = "应用服务";
                servicecard.menu.getServiceCardMenu().forEach(function (menu) {
                    if (menu.itemCode == card.directoryId) {
                        menuName = menu.itemName;//获取菜单名称
                    }
                });
                var clueExtendInfo = {
                    eventType: "CET003014",
                    sourceCode: "SC000001",
                    bizType: "DPRM|" + menuName + '|' + cate.itemName + '|' + card.name,//菜单 三级 名称
                    location: "LO202210250002",
                    action: "AC202210250001",
                    userId: UserInfoPreload.id,//帐号的userID 可能是团队帐号的
                    eventTimestamp: new Date().getTime(),
                    extendInfo: angular.toJson({
                        serviceID: card.cardItem
                    }),
                };
                biAnalyticService.bianalyticLink("服务卡片点击", card.cardItem, "DPRM0056", clueExtendInfo)
                // 查看卡片灰度是否写入cookie
                servicecard.setHdGrey(card).then(function () {
                    //检查卡片涉及到的协议，暂时不支持团队帐号
                    auiAgreementHelper.checkAgreements(sysParamCfg.cardIDs[card.cardItem] ? sysParamCfg.cardIDs[card.cardItem] : [], function () {
                    }).then(function (rs) {
                        if (rs && rs.signed) {
                            servicecard.cards.click(card, event);
                        }
                    });
                })

            };
            $scope.getServiceCards = function () {
                var dirId = $state.params.dirId;
                return servicecard.cards.getServiceCards(dirId);
            };

            $scope.hasUncustomizedNewServiceCards = function (cateId) {
                var dirId = $state.params.dirId;
                return servicecard.customizer.hasUncustomizedNewServiceCards(dirId, cateId);
            };

            $scope.openCustomizer = function (cate) {
                ngDialog.open({
                    template: 'pages/common/dialog.service.manage.html',
                    className: '',
                    controller: ['$scope', 'auiDialog', function ($scope, auiDialog) {
                        // 分类下的卡片数据
                        $scope.category = cate;

                        $scope.closeDialog = function () {
                            var currentDirId = $state.params.dirId;

                            // 至少选择一项服务
                            if (false === servicecard.customizer.hasCustomizedServiceCards()) {
                                auiDialog.warn('请至少选择一项服务。');
                                return;
                            }

                            // 如果当前所在目录下无定制卡片则跳转到首页
                            if (currentDirId && !servicecard.customizer.hasCustomizedServiceCards(currentDirId)) {
                                $state.go('home');
                            }

                            ngDialog.close();
                        };

                        // 定制卡片
                        $scope.customizeCard = function (card) {
                            servicecard.customizer.customize(card);
                        }

                    }]
                });
            }
        }]);
});

